import { useTranslation } from '../../locales/useTranslation'

const MapIcon = ({ active }) => {
  const c = active ? 'var(--green)' : 'var(--ink-muted)'
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M9 3L3 6v15l6-3 6 3 6-3V3l-6 3-6-3z" stroke={c} strokeWidth="1.8" strokeLinejoin="round"/>
      <line x1="9" y1="3" x2="9" y2="18" stroke={c} strokeWidth="1.8"/>
      <line x1="15" y1="6" x2="15" y2="21" stroke={c} strokeWidth="1.8"/>
    </svg>
  )
}

const BookingsIcon = ({ active }) => {
  const c = active ? 'var(--green)' : 'var(--ink-muted)'
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="3" y="4" width="18" height="18" rx="2" stroke={c} strokeWidth="1.8"/>
      <line x1="3" y1="9" x2="21" y2="9" stroke={c} strokeWidth="1.8"/>
      <line x1="8" y1="2" x2="8" y2="6" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
      <line x1="16" y1="2" x2="16" y2="6" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  )
}

const ChargerIcon = ({ active }) => {
  const c = active ? 'var(--green)' : 'var(--ink-muted)'
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="2" width="12" height="17" rx="2" stroke={c} strokeWidth="1.8" fill="none"/>
      <path d="M8 10L11 7V11H13L10 15V11H8Z" fill={c}/>
      <path d="M16 8H20M16 12H20" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  )
}

const ProfileIcon = ({ active }) => {
  const c = active ? 'var(--green)' : 'var(--ink-muted)'
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke={c} strokeWidth="1.8"/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={c} strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  )
}

const BottomNav = ({ activeTab, setActiveTab, session, onLoginClick }) => {
  const { t } = useTranslation()

  // Not logged in — show only Kaart + Login button
  if (!session) {
    return (
      <div style={{
        flexShrink: 0,
        background: 'var(--white)',
        borderTop: '1px solid var(--cream-dark)',
        padding: '8px 24px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 30,
        boxShadow: '0 -2px 12px rgba(0,0,0,0.06)'
      }}>
        {/* Kaart tab */}
        <button
          onClick={() => setActiveTab('kaart')}
          style={{
            background: 'none', border: 'none',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 4,
            cursor: 'pointer', padding: '3px 16px',
            opacity: 1, fontFamily: 'DM Sans, sans-serif'
          }}>
          <MapIcon active={true} />
          <span style={{ fontSize: 10, color: 'var(--green)', fontWeight: 700 }}>
            {t('nav_kaart')}
          </span>
        </button>

        {/* Buurtlader wordmark */}
        <div style={{
          display: 'flex', alignItems: 'center', gap: 7
        }}>
          <div style={{
            width: 7, height: 7, borderRadius: '50%',
            background: 'var(--green)'
          }} />
          <span style={{
            fontFamily: 'Fraunces, serif', fontWeight: 900,
            fontSize: 16, color: 'var(--ink)'
          }}>
            Buurtlader
          </span>
        </div>

        {/* Login button */}
        <button
          onClick={onLoginClick}
          style={{
            background: 'var(--green)',
            border: 'none', borderRadius: 12,
            padding: '9px 18px',
            color: 'white', fontWeight: 700,
            fontSize: 13, cursor: 'pointer',
            fontFamily: 'DM Sans, sans-serif'
          }}>
          Inloggen
        </button>
      </div>
    )
  }

  // Logged in — show full nav
  const tabs = [
    { id: 'kaart', label: t('nav_kaart'), Icon: MapIcon },
    { id: 'boekingen', label: t('nav_boekingen'), Icon: BookingsIcon },
    { id: 'laadpalen', label: t('nav_laadpalen'), Icon: ChargerIcon },
    { id: 'profiel', label: t('nav_profiel'), Icon: ProfileIcon },
  ]

  return (
    <div style={{
      flexShrink: 0,
      background: 'var(--white)',
      borderTop: '1px solid var(--cream-dark)',
      padding: '8px 0 20px',
      display: 'flex',
      justifyContent: 'space-around',
      zIndex: 30,
      boxShadow: '0 -2px 12px rgba(0,0,0,0.06)'
    }}>
      {tabs.map(({ id, label, Icon }) => (
        <button
          key={id}
          onClick={() => setActiveTab(id)}
          style={{
            background: 'none', border: 'none',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: 4,
            cursor: 'pointer', padding: '3px 16px',
            opacity: activeTab === id ? 1 : 0.5,
            transition: 'opacity 0.2s',
            fontFamily: 'DM Sans, sans-serif'
          }}>
          <Icon active={activeTab === id} />
          <span style={{
            fontSize: 10,
            color: activeTab === id ? 'var(--green)' : 'var(--ink-muted)',
            fontWeight: activeTab === id ? 700 : 500
          }}>
            {label}
          </span>
        </button>
      ))}
    </div>
  )
}

export default BottomNav
